/* ==========================================================================
   checkbox
   ==========================================================================*/
$(document).ready(function() {
	function chkClicked() {
    $('input[type="checkbox"]:checked, input[type="radio"]:checked').parent().addClass('on');
    $('input[type="checkbox"]:not(:checked), input[type="radio"]:not(:checked)').parent().removeClass('on');
	}

	$chkInputs = $('input[type="checkbox"], input[type="radio"]');
	$chkInputs.on('change', function() {
		chkClicked();
	});

	$chkInputs.each(function(i, chk){
		chkClicked($(chk));
	});
});

/* ==========================================================================
   focus
   ==========================================================================*/
$(document).ready(function(){
	//  textBox は テキストボックス全てを指定。
	var textBox = $("input#textfield, textarea, option, select");

	//  条件は テキストボックスにフォーカスされたら。
	textBox.focus(function(){
		//  class名 "textFocus" を追加。（文字色を濃くする）
		$(this).addClass("focus");
	//  逆に テキストボックスからフォーカスが失われたとき。
	}).blur(function(){
		//  if条件は テキストボックスの数値が 空（０文字）のとき
		if($(this).val() == ''){
			//  テキストボックスの中身を 元の初期値（value）にする
			//  classも外す（文字色を元の薄い色に戻す）
			$(this).val(this.defaultValue).removeClass("focus");
		}
	});
});

/* ==========================================================================
   FormGuide
   ========================================================================== */
function ShowFormGuide(obj, GuideSentence) {
  if( obj.placeholder == '' ) {
    obj.placeholder = GuideSentence;
    obj.style.background = '#fffef2';
  }
}
function HideFormGuide(obj, GuideSentence) {
  if( obj.placeholder == GuideSentence ) {
    obj.placeholder='';
    obj.style.background = '#fff';
  }
}

/* ==========================================================================
   半角入力
   ========================================================================== */
$(document).ready(function() {
    // ime-modeが使えるか
    var supportIMEMode = ('ime-mode' in document.body.style);
    // 非ASCII
    var noSbcRegex = /[^\x00-\x7E]+/g;
    // 1バイト文字専用フィールド
    $('.sbc_field').on('keydown blur paste', function(e) {
      // ime-modeが使えるならスキップ
      if (e.type == 'keydown' || e.type == 'blur')
          if (supportIMEMode) return;
      // 2バイト文字が入力されたら削除
      var target = $(this);
      if(!target.val().match(noSbcRegex)) return;
      window.setTimeout( function() {
        target.val( target.val().replace(noSbcRegex, '') );
      }, 1);
    });
});

/* ==========================================================================
   フォーカス移動
   ========================================================================== */
$(function () {
  // 1
  $('input[name=zipcode1]').bind('change keyup', function(){
    // 半角数字4文字入力
    if ($(this).val().match(/^[0-9]{3}$/)) {
    // 数字限定せず4文字入力の場合
    // if ($(this).val().length == 4) {
      // 次入力欄にフォーカス移動
      $('input[name=zipcode2]').focus();
    }
  });
  // 2
  $('input[name=zipcode2]').bind('change keyup', function(){
    if ($(this).val().match(/^[0-9]{4}$/)) {
      // フォーカスを外す
      $(this).blur();
    }
  });
});


/* ==========================================================================
   check-cage
   ========================================================================== */
$(function(){
	$('.check-cage').each(function() {
		$(this).children('label').on('click', function() {
			$(this).parent().children('input').removeClass('check');
			if ($(this).prev().val() == '1') {
				$(this).parent().children('.check01').addClass('check');
				$(this).parent().children('.check01').prop("checked",true);
			} else if ($(this).prev().val() == '2') {
				$(this).parent().children('.check01,.check02').addClass('check');
				$(this).parent().children('.check02').prop("checked",true);
			} else if ($(this).prev().val() == '3') {
				$(this).parent().children('.check01,.check02,.check03').addClass('check');
				$(this).parent().children('.check3').prop("checked",true);
			} else if ($(this).prev().val() == '4') {
				$(this).parent().children('.check01,.check02,.check03,.check04').addClass('check');
				$(this).parent().children('.check04').prop("checked",true);
			} else if ($(this).prev().val() == '5') {
				$(this).parent().children('input').addClass('check');
				$(this).parent().children('.check05').prop("checked",true);
			}
		});
	});
});

/* ==========================================================================
   formCheck
   ========================================================================== */
function formCheck(){
  var flag = 0;

  if(document . search_words . keyword . value == "" ) {
    flag = 1;
    document . getElementById( 'error_txt' ) . style . display = "block";
  } else {
    document . getElementById( 'error_txt' ) . style . display = "none";
  }

  if(flag) {
    return false;
  } else {
    return true;
  }
}